export async function importBuildTarget(project, target) {
  try {
    switch (project.toLowerCase()) {
      case "draftupai":
        if (target === 'www') {
          return await import("./draftupai/www.js");
        } else if (target === 'app') {
          return await import("./draftupai/app.js");
        } else if (target === 'service') {
          return await import("./draftupai/service.js");
        }
        break;
      case "polski_rzeczoznawca":
        if (target === 'www') {
          return await import("./polski_rzeczoznawca/www.js");
        } else if (target === 'app') {
          return await import("./polski_rzeczoznawca/app.js");
        } else if (target === 'service') {
          return await import("./polski_rzeczoznawca/service.js");
        }
        break;
      case "vendorsnear":
        if (target === 'www') {
          return await import("./vendorsnear/www.js");
        } else if (target === 'app') {
          return await import("./vendorsnear/app.js");
        } else if (target === 'service') {
          return await import("./vendorsnear/service.js");
        }
        break;
      default:
        throw new Error(`Missing project/target envs: ${project}, ${target}`);
    }
  } catch (err) {
    throw new Error(err.message);
  }
}
